import React, { useEffect } from 'react'
import { useStores } from '@trivie/core'
import { HistoryRow } from '@trivie/ui-mobile'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router'

export const HistoryScreen = observer(() => {
  const { quizStore, userStore } = useStores()
  const { getQuizHistory, history: historyList } = quizStore
  const { user, enterpriseTier } = userStore

  const history = useHistory()

  const goToResults = (quiz: any) => {
    if (user) {
      history.push(`/results/${quiz.result_id}`, { from: 'quiz-history', quiz })
    }
  }

  useEffect(() => {
    if (user) {
      getQuizHistory(user?.id)
    }
  }, [])

  return (
    <>
      {historyList.map((quiz: any) => (
        <div style={{ cursor: 'pointer' }}>
          <HistoryRow
            enterpriseTier={enterpriseTier}
            key={quiz.result_id || quiz.date_finished}
            title={quiz?.title}
            date={quiz.date_finished}
            correct={quiz.questions_correct}
            total={quiz.questions_total}
            medal={quiz.medal_level}
            onPress={() => goToResults(quiz)}
          />
        </div>
      ))}
    </>
  )
})
